"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewsRow;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _numeral = _interopRequireDefault(require("numeral"));
var _moment = _interopRequireDefault(require("moment"));
var _S3Image = _interopRequireDefault(require("Pure/S3Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function NewsRow(_ref) {
  var _data$images, _data$images2;
  let {
    data = {},
    blank = false,
    fields
  } = _ref;
  _numeral.default.locale('en');
  _moment.default.locale('fr');
  const blank_props = blank === true ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const link = /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({
    className: "u-link-only"
  }, blank_props, {
    href: (0, _Routing.URL)('AdminNewsDashboard') + '/' + data.id
  }), "Page de l'actualit\xE9");
  let output = /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell News-images"
  }, (_data$images = data.images) !== null && _data$images !== void 0 && _data$images[0] ? /*#__PURE__*/_react.default.createElement(_S3Image.default, {
    data: (_data$images2 = data.images) === null || _data$images2 === void 0 ? void 0 : _data$images2[0],
    variant: 400,
    ratio: "1:1"
  }) : undefined), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell News-date"
  }, data.date, link), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell News-title"
  }, data.title, link));
  return output;
}
